module.exports = __webpack_public_path__ + "img/american-violence-1.6b2ebd29.png";